import { Navigate, Route } from 'react-router-dom';

import ScreenRenderer from './screen-renderer/screen-renderer.component';
import WizardInitialisation from './wizard-initialisation/wizard-initialisation.component';

export function WizardRoutes() {
    return (
        <Route path='wizard/:functionalityId'>
            <Route path=':wizardId'>
                <Route
                    index
                    element={<WizardInitialisation />}
                />
                <Route path='screens'>
                    <Route
                        path=':screen_type'
                        element={<ScreenRenderer />}
                    />
                    <Route
                        index
                        element={<Navigate to='..' />}
                    />
                </Route>
            </Route>
        </Route>
    );
}
